export default __webpack_public_path__ + "static/media/slack.01989c85.svg";